import React, { Suspense, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import AnalyticsTracker from "../components/AnalyticsTracker";
import InitialPageLoader from "../components/InitialPageLoader";
import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";
import ProtectedRoute from "./ProtectedRoute";
import { preloadWorkspacePages, routes } from "./Routes";

const routeTypeComponentMap = {
  public: PublicRoute,
  private: PrivateRoute,
  protected: ProtectedRoute,
};

const AppRouter = ({ userData, loading }) => {
  const signedIn = Boolean(userData?.email);
  useEffect(() => {
    if (!signedIn) return undefined;
    const idle = window.requestIdleCallback || ((callback) => window.setTimeout(callback, 1500));
    const cancel = window.cancelIdleCallback || window.clearTimeout;
    const handle = idle(preloadWorkspacePages);
    return () => cancel(handle);
  }, [signedIn]);

  if (loading) {
    return (
      <InitialPageLoader className="screen-center" label="Loading Studiozflo…" />
    );
  }

  return (
    <Suspense fallback={<InitialPageLoader className="screen-center" label="Loading page…" />}>
      <AnalyticsTracker routes={routes} user={userData} loading={loading} />
      <Routes>
        {routes.map((route, index) => {
          const RouteComponent =
            routeTypeComponentMap[route?.type] || React.Fragment;
          const element = route?.type ? (
            <RouteComponent {...route} userData={userData}>
              {route.element}
            </RouteComponent>
          ) : (
            route.element
          );

          return <Route key={index} path={route.path} element={element} />;
        })}
      </Routes>
    </Suspense>
  );
};

export default AppRouter;
